import { ChevronLeft } from 'lucide-react';
import type { ReactNode } from 'react';

import {
  goBackOrFallback,
  useIonBackRouter,
} from '@/core/lib/ion-back-navigation';
import { useDictionary } from '@/core/providers/dictionary-provider';

interface BackButtonProps {
  to: string;
  label?: ReactNode;
  className?: string;
}

export function BackButton({ to, label, className }: BackButtonProps) {
  const router = useIonBackRouter();
  const dict = useDictionary();
  const backLabel = label ?? dict.ui.back;

  const handleBack = () => {
    goBackOrFallback(router, to);
  };

  return (
    <button
      type="button"
      onClick={handleBack}
      className={`inline-flex items-center gap-1 text-base font-medium text-foreground hover:opacity-80 active:opacity-60 transition-opacity -ml-1 cursor-pointer touch-manipulation ${className || ''}`}
    >
      <ChevronLeft className="h-5 w-5" />
      {backLabel && <span>{backLabel}</span>}
    </button>
  );
}
